import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-dropdown-button-option',
    templateUrl: './dropdown-button-option.component.html',
    styleUrls: ['./dropdown-button-option.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DropdownButtonOptionComponent {

    @Input() disabled: boolean = false;

    constructor() {
    }

}
